// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"660da56c","787":"58f15db9"}[chunkId] + ".chunk.js";
};